export const meta = {
  title: "Srikar Sunchu - Resume | Design Engineer",
  meta: [
    { charset: "utf-8" },
    { equiv: "Content-Type", content: "text/html" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    {
      name: "description",
      content:
        "Srikar Sunchu - Design Engineer | Frontend Developer specializing in React, TypeScript, and creative animation",
    },
    { name: "language", content: "en" },
    {
      name: "keywords",
      content: "Srikar, Sunchu, Design Engineer, Frontend Developer, React, TypeScript, CV, Resume",
    },
    { name: "author", content: "Srikar Sunchu" },
    { name: "copyright", content: "Srikar Sunchu" },
    { name: "theme-color", content: "#ff0000" },
  ],
};
